//. Third-party Library
import { Card } from "antd"

import styles from '../../index.module.css'

export const InfoCard = ({
    title = '',
    component = <></>
}) => {
    return (
        <Card className={styles['card']}>
            <h2 style={{ marginBottom: '1.2em'}}>{title}</h2>
            {component}
        </Card>
    )
}

export const ChildCard = ({
    component = <></>
}) => {
    return (
        <div style={{ backgroundColor: '#000', borderColor: '#000', padding: '1em', color: '#fff', marginTop: '2em', borderRadius: '12px'}}>
            {component}
        </div>
    )
}